<template>
  <div id="yarn">
    <el-row>
      <el-button id="addBtn" type="primary" @click="toAddCustomer">新增纱支</el-button>
    </el-row>
    <el-form id="queryForm" :inline="true" :model="queryForm" class="demo-form-inline">
      <YarnSelector ref="yarnSelector"/>
      <el-form-item label="纱支">
        <el-input v-model="queryForm.user"></el-input>
      </el-form-item>
      <el-form-item label="支数">
        <el-input v-model="queryForm.user"></el-input>
      </el-form-item>
      <el-form-item label="股数">
        <el-input v-model="queryForm.user"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 80%"
      :default-sort="{prop: 'date', order: 'descending'}"
      border
    >
      <el-table-column prop="yarnType" label="纱支类型" sortable></el-table-column>
      <el-table-column prop="yarnName" label="纱支" sortable></el-table-column>
      <el-table-column prop="shortName" label="简称" sortable></el-table-column>
      <el-table-column prop="yarnCount" label="支数"></el-table-column>
      <el-table-column prop="yarnPly" label="股数"></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="query"
      :current-page.sync="tableData.pageNum"
      :page-sizes="[10,20,30,40,50]"
      :total="tableData.total"
      layout="total,sizes, prev, pager, next"
    ></el-pagination>

    <el-dialog title="添加纱支" :visible.sync="dialogFormVisible" :width="dialogWidth">
      <el-form :model="form">
        <YarnSelector ref="yarnSelector" :label-width="formLabelWidth"/>
        <el-form-item label="纱支名称" :label-width="formLabelWidth">
          <el-input v-model="form.yarnName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="纱支简称" :label-width="formLabelWidth">
          <el-input v-model="form.shortName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="支数" :label-width="formLabelWidth">
          <el-input v-model="form.yarnCount" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="股数" :label-width="formLabelWidth">
          <el-input v-model="form.yarnPly" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import YarnSelector from '@/components/YarnSelector.vue';
export default {
  components: {
    YarnSelector,
  },
  data() {
    return {
      dialogFormVisible: false,
      form: {},
      formLabelWidth: "120px",
      dialogWidth: "600px",
      tableData:[],
      queryForm: {
        user: ""
      }
    };
  },
  created: function() {
    console.log("Yarn created");
    this.query();
  },
  methods: {
    formatter(row) {
      return row.address;
    },
    onSubmit() {
      console.log("submit!");
    },
    toAddCustomer() {
      // this.$router.push("/customer/add");
      this.dialogFormVisible = true;
    },
    query() {
      
    }
  }
};
</script>

<style scoped>
#addBtn {
  float: right;
}
#queryForm {
  margin-top: 20px;
  margin-bottom: 20px;
}
.el-table {
  margin: auto;
}
</style>